import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useFormContext } from "@4uhub/lib4uhub";
import { IIServiceType } from "../../../../../../../models/i-service-type";
import { TIServiceForm } from "../../iServiceSchema";
import { IServiceType } from "../IServiceType";
import { useIServiceType } from "../useIServiceType";
import { Protheus } from "./Protheus";

interface IProtheusWrapperProps {
  iServiceTypes: IIServiceType[];
}

const FIELD_NAME = "protheus";

const PROTHEUS_IMAGE = { src: "/iServices/protheus.png", alt: "Protheus" };

const translationPath = "page.4uBus.register.iService.";

export const ProtheusWrapper = memo(
  ({ iServiceTypes }: IProtheusWrapperProps) => {
    const { id } = useParams();

    const { t } = useTranslation();

    const { setValue, getValues } = useFormContext<TIServiceForm>();

    const { protheusValues } = useIServiceType();

    const protheusType = iServiceTypes.find(
      (item) => item.code === protheusValues.code,
    );

    const [isSelected, setIsSelected] = useState(() => {
      const protheus = getValues(FIELD_NAME);
      const iServiceType = getValues("iServiceType");
      return !!protheus || iServiceType?.code === protheusValues.code;
    });

    const handleConfirm = () => {
      if (protheusType) {
        setValue("iServiceType", protheusType);
      }
      setValue(FIELD_NAME, protheusValues.defaultValues);
      setIsSelected(true);
    };

    const handleClearConfigs = () => {
      setValue("configs", null);
      setValue("companyDigitalCertificate", null);
      setValue("iServiceType", null);
      setValue(FIELD_NAME, null);
      setIsSelected(false);
    };

    const handleOpen = () => {
      setValue(FIELD_NAME, protheusValues.defaultValues);
    };

    const handleCloseSelected = () => {
      setValue(FIELD_NAME, protheusValues.defaultValues);
    };

    const isEditingScreen = !!id;

    if (!protheusType) {
      return null;
    }

    return (
      <IServiceType
        img={PROTHEUS_IMAGE}
        renderComponent={() => <Protheus />}
        isSelected={isSelected}
        isEditingScreen={isEditingScreen}
        getFormattedData={() => ({})}
        onConfirm={handleConfirm}
        onClearConfigs={handleClearConfigs}
        onOpen={handleOpen}
        onCloseSelected={handleCloseSelected}
        iServiceTypeName={FIELD_NAME}
        serviceName={t(translationPath + "protheus")}
        showConfirmButton={false}
      />
    );
  },
);
